import { getEnv } from './env';

interface KeycloakConfig {
  url: string;
  realm: string;
  clientId: string;
}

const keycloakConfig: KeycloakConfig = {
  url: getEnv('REACT_APP_KEYCLOAK_URL', 'http://localhost:9080'),
  realm: getEnv('REACT_APP_KEYCLOAK_REALM', 'jhipster'),
  clientId: getEnv('REACT_APP_KEYCLOAK_CLIENT_ID', 'web_app'),
};

export default keycloakConfig;